import {createAction, handleActions} from 'redux-actions';
// import axios from 'axios/index';

export const setWageLoading = createAction('SET_WAGE_LOADING');
export const setDamageLoading = createAction('SET_DAMAGE_LOADING');
export const setStockLoading = createAction('SET_STOCK_LOADING');
export const setPartGroupLoading = createAction('SET_PARTGROUP_LOADING');
export const setPartTypeLoading = createAction('SET_PARTTYPE_LOADING');
export const setFixLevelLoading = createAction('SET_FIXLEVEL_LOADING');

export const LoadingReducer = (defaultState) => handleActions({
  [setWageLoading](state, action) {
    const {payload} = action;
    return {
      ...state,
      wage: payload.loading,
    };
  },
  [setDamageLoading](state, action) {
    const {payload} = action;
    return {
      ...state,
      damage: payload.loading,
    };
  },
  [setStockLoading](state, action) {
    const {payload} = action;
    return {
      ...state,
      stock: payload.loading,
    };
  },
  [setPartGroupLoading](state, action) {
    const {payload} = action;
    return {
      ...state,
      partGroup: payload.loading,
    };
  },
  [setPartTypeLoading](state, action) {
    const {payload} = action;
    return {
      ...state,
      partType: payload.loading,
    };
  },
  [setFixLevelLoading](state, action) {
    const {payload} = action;
    return {
      ...state,
      partType: payload.loading,
    };
  },
}, defaultState);

export default LoadingReducer;



// WEBPACK FOOTER //
// ./src/stores/CarDamage/LoadingReducer.js